/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rooms_Empty_StateInputs */



/**
* | output |
* | --- |
* | "Playing in several rooms? Add them to show each table's room in the seating." |
*
* @param {Rooms_Empty_StateInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rooms_empty_state = /** @type {((inputs?: Rooms_Empty_StateInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rooms_Empty_StateInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous jouez dans plusieurs salles ? Ajoutez-les pour afficher la salle de chaque table dans le placement.")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Juega en varias salas? Añádalas para mostrar la sala de cada mesa en el emparejamiento.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Jogando em várias salas? Adicione-as para mostrar a sala de cada mesa na distribuição.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Giochi in più sale? Aggiungile per mostrare la sala di ogni tavolo nell'abbinamento.")
	return /** @type {LocalizedString} */ ("Playing in several rooms? Add them to show each table's room in the seating.")
});